<template lang="html">
    <div id="page__forward-search" class="toolbar-search">
        <z-select
            v-model="filter.type" light
            name="filter_city-type"
            id="filter_city-type"
            v-on:input="onFilter"
        >
            <option value="" selected> Тип расчета (любой) </option>
            <option v-bind:value="1"> По весу </option>
            <option v-bind:value="2"> По объёму </option>
        </z-select>

        <z-input-autocomplete
            v-model="filter.city_id"
            v-bind:callback="getCities"
            v-on:clear="clearCity"
            v-on:input="onFilter"
            class="search-autocomplete"
            placeholder="Город экспедирования"
            display-property="value"
            property="id"
            return="id"
            no-resize light
            id="filter_city"
            name="filter_city"
            v-bind:error="errors.first('filter_city')"
            data-vv-name="filter_city"
            v-bind:data-vv-as="' '"
            ref="city"
        ></z-input-autocomplete>

        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-bind:disabled="!hasFilter" v-on:click="onReset"></z-icon-button>
    </div>
</template>
<script>
    import ZIconButton from '@/components/ZIconButton.vue';
    import ClickOutside from 'vue-click-outside';
    import ZSelect from '@/components/ZSelect';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: { ZIconButton, ZSelect, ZInputAutocomplete},
        directives: {ClickOutside},
        data() {
            return {
                loading: false,
                filter: {
                    city_id: null,
                    type: ''
                },
                filterDefault: {
                    city_id: null,
                    type: ''
                },
            }
        },
        created() {
            this.resolveQueryFilter();
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
        },
        watch: {
            'filter.city_id'(newVal, oldVal) {
                if (oldVal != newVal) this.onFilter();
            }
        },
        methods: {
            /**
             * Подставление города
             */
            getCities(value) {
                let filter = {model: [['name', '%', value]]};
                if (value.length >= 3) return this.$store.dispatch('cost/getCitiesNew', {page: 1, order_by: 'name', order_type: 'asc', count: 20, filter: filter}).then(result => {
                    if (!result || !result.data) return [];
                    return result.data;
                });
            },
            /**
             * Очистка города
             */
            clearCity() {
                this.filter.city_id = null;
                this.onFilter();
            },
            /**
             * Фильрация
             */
            doFilter() {
                this.$nextTick(() => {
                    let filter = {};
                    Object.keys(this.filter).map(key => {
                        if (this.filter[key]) filter[key] = this.filter[key];
                    });

                    this.$router.push({ name: this.$route.name, params: this.$route.params, query: { filter: JSON.stringify(filter)}});
                    this.$root.$emit('refresh-table', 'forwardingprices');
                });
            },
            /**
             * Подставлене фильтра при перезагрузки
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Фильтрация
             */
            onFilter() {
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'forwardingprices');
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'forwardingprices');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ForwardingToolbar.vue?29514612